import { styled } from "@mui/material/styles";
import { PopupHeader as PopupHeaderComponent } from "components/popup/header";
import backArrowIcon from "assets/images/icons/arrow-short.svg";
import { PlainButton } from "components/button/plain";

export const Item = styled("div", {
  label: "item",
})`
  color: ${({ theme }) => theme.palette.color.text.primary};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;

  & + & {
    margin-top: ${({ theme }) => theme.spacing(3)};
  }
`;

export const ItemTitle = styled("h3", {
  label: "item-title",
})`
  font-weight: 500;
  line-height: 1.3;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const PopupHeader = styled(PopupHeaderComponent, {
  label: "popup-header",
})`
  && {
    padding-left: 0;
    text-align: left;
  }
`;

export const ArrowIcon = styled(backArrowIcon, {
  label: "arrow-icon",
})`
  fill: currentColor;
  transform: rotate(-180deg);
  width: ${({ theme }) => theme.spacing(2)};
  stroke: currentColor;
`;

export const OpenPopupButton = styled(PlainButton, {
  label: "open-popup-button",
})`
  display: flex;
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
  border-radius: 50%;
  transition: ${({ theme }) => theme.transitions.create("background")};

  border: 1px solid ${({ theme }) => theme.palette.color.primary[90]};
  margin-left: ${({ theme }) => theme.spacing(1)};
  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;
